// src/utils/groupBy.ts

export function groupByCategory<T extends { category?: string }>(
  list: T[]
): Record<string, T[]> {
  return list.reduce((acc, item) => {
    const category = item.category ?? "Uncategorized";
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {} as Record<string, T[]>);
}
